import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'wz-form-group-part-item',
  templateUrl: './form-group-part-item.component.html',
  styleUrls: ['./form-group-part-item.component.scss'],
  standalone: false,
})
export class FormGroupPartItemComponent {
  @Input() hasDelete!: boolean;
  @Output() delete = new EventEmitter();

  onDeleteClick() {
    this.delete.next(null);
  }
}
